export default "__VITE_ASSET__39e9d509__"